import { graphql, Link, useStaticQuery } from "gatsby";
import React, { useState } from "react";
import logo from "../../../images/logo.svg";
// import CTAModal from "../cta-modal/cta-modal";
import { GatsbyImage } from "gatsby-plugin-image";
import parse from "html-react-parser";
import DemoButton from './../../demoButton/demoButton';
import HeaderBanner from "./../header-banner/header-banner";
import * as s from "./header.module.css";
import MobileNav from "./mobile-nav";

const Header = ({ scrollToForm }) => {

  const [activeSubmenu, setActiveSubmenu] = useState(null);

  const toggleSubmenu = (index) => {
    if (activeSubmenu == index) {
      setActiveSubmenu(null);
    } else {
      setActiveSubmenu(index);
    }
  }

  const {
    wpMenu: { wpMenuItems },
  } = useStaticQuery(graphql`
    query HeaderMenuQuery {
      wpMenu(locations: {eq: HEADER_MENU}) {
        wpMenuItems: menuItems {
          nodes {
            id
            uri
            title
            target
            label
            linkRelationship
            cssClasses
            parentId
            connectedNode {
              node {
                ... on WpPage {
                  uri
                  title
                }
              }
            }
            acfHeaderMenu {
              menuItemSettings {
                type
                aiPowered
                description
                icon {
                  altText
                  localFile {
                    publicURL
                  }
                }
                image {
                  altText
                  localFile {
                    publicURL
                    childImageSharp {
                      gatsbyImageData(quality: 100)
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const flatListToHierarchical = (
    data = [],
    { idKey = "id", parentKey = "parentId", childrenKey = "items" } = {}
  ) => {
    const tree = []
    const childrenOf = {}
    data.forEach(item => {
      const newItem = { ...item }
      const { [idKey]: id, [parentKey]: parentId = 0 } = newItem
      childrenOf[id] = childrenOf[id] || []
      newItem[childrenKey] = childrenOf[id]
      parentId
        ? (childrenOf[parentId] = childrenOf[parentId] || []).push(newItem)
        : tree.push(newItem)
    })
    return tree
  }

  let wpMenuItemsTree = flatListToHierarchical(wpMenuItems.nodes);

  return (
    <div className={`w-100 ${s.headerWrapper}`}>
      <HeaderBanner />
      <header className={s.header}>
        <div className="container position-relative">
          <div className="d-flex justify-content-between">
            <Link to="/" className="pt-xl-4">
              <img
                alt="logo"
                width={130}
                height={38}
                src={logo}
                loading="eager"
                className="d-none d-xl-block"
              />
              <img
                alt="logo-mobile"
                width={130}
                height={38}
                src={logo}
                loading="eager"
                className="d-xl-none"
              />
            </Link>
            <div className="d-none d-xl-flex align-items-center">
              <nav className={`d-flex align-items-center`}>
                {wpMenuItemsTree.map((mi, i) => {
                  let hasSubMenu = !!mi.items && mi.items.length > 0;
                  return (
                    <div
                      onClick={() => { toggleSubmenu(i) }}
                      key={`header-menu-item-${i}`}
                      className={`mr-3 ${i == activeSubmenu ? s.active : ''} ${s.menuItem} ${hasSubMenu ? s.hasSubmenu : ""}`}
                    >
                      {hasSubMenu && (
                        <>
                          <span>{mi.label}</span>
                          <div className={`${s.subMenu}`}>
                            {mi.items.map((smi, j) => (
                              <SubmenuItem item={smi} key={`header-submenu-item-${i}-${j}`} />
                            ))}
                          </div>
                        </>
                      )}
                      {!hasSubMenu && !!mi.uri && (
                        <>
                          {!!mi.target && mi.target === "_blank" && (
                            <a href={mi.uri} rel="noreferrer" target="_blank">
                              {mi.label}
                            </a>
                          )}
                          {!mi.target && <Link to={mi.uri}>{mi.label}</Link>}
                        </>
                      )}
                    </div>
                  );
                })}
              </nav>
              <div className="header-cta-outline position-relative">
                <Link to={'https://demo.orders.co?s=w'} target="_blank" className="header-cta">Website Builder</Link>
                <div className="blue-badge position-absolute" style={{ top: '-6px', right: '-4px' }}>
                  <span style={{ fontSize: '12px' }}>AI</span> powered
                </div>
              </div>
              <DemoButton scrollToForm={scrollToForm} classes={["ml-xl-1"]}>Schedule a DEMO</DemoButton>
            </div>
          </div>
        </div>
        <div className="d-xl-none">
          <MobileNav menuItems={wpMenuItemsTree} />
        </div>
      </header>
      {/* <CTAModal /> */}
    </div>
  );
};

export default Header;


const SubmenuItem = ({ item }) => {
  let settings = item?.acfHeaderMenu?.menuItemSettings;
  // if (settings?.type != 'none' && settings?.type != null)
  //   console.log(settings)

  switch (settings?.type) {
    case 'small':
      let icon = {
        src: settings?.icon?.localFile?.publicURL,
        alt: settings?.icon?.altText,
      }
      return <>
        {!!item.uri && (
          <div className={`col-3 px-2 ${s.menuItem}`} >
            <Link to={item.uri} className="d-flex align-items-start" style={{ gap: '4px' }}>
              {!!icon?.src && <img src={icon?.src} alt={icon?.alt} style={{ maxWidth: '20px' }} loading="lazy" />}
              <div className="d-flex flex-column">
                <b className={`${settings?.aiPowered ? s.aiPowered : ''}`}>{item.label}</b>
                {!!settings.description && <span>{parse(settings.description)}</span>}
              </div>
            </Link>
          </div>
        )}
      </>
      break;
    case 'large':
      let image = {
        src: settings?.image?.localFile?.publicURL,
        data: false,
        // data: settings?.image?.localFile?.childImageSharp?.gatsbyImageData,
        alt: settings?.image?.altText,
      }
      return <>
        {!!item.uri && (
          <div className={`col px-2  ${s.menuItem}`} >
            <Link to={item.uri} className="d-flex" >
              {!!image?.data ?
                <GatsbyImage
                  placeholder="none"
                  loading="eager"
                  image={image.data}
                  alt={image.alt}
                  className="w-auto mw-100 mh-100" />
                : <>
                  {!!image?.src && <img src={image?.src} alt={image?.alt} className={`${s.largeImage} w-auto mw-50 mh-100`} loading="lazy" />}
                </>
              }
              <div className="col-6 d-flex flex-column">
                <b className={`${settings?.aiPowered ? s.aiPowered : ''}`}><label>{item.label}</label></b>
                {!!settings.description && <span style={{ marginTop: '14px' }}>{parse(settings.description)}</span>}
              </div>
            </Link>
          </div>
        )}
      </>
      break;
    default:
      return <div className={`col-3 ${s.menuItem}`} >
        {!!item.uri && (
          <Link to={item.uri}>{item.label}</Link>
        )}
        {!item.uri && <span>{item.label}</span>}
      </div>
      break;
  }

}